import { ApiConnector, GET } from "./request.service";

export default (() => {
  const API = ApiConnector("/offices");
  return {
    GetCityOffices: async (item) =>
      await API(GET, `/${item}`, false, {
        token: "!Aa12345",
        size: 9999,
      }).call(),
  };
})();
